module.exports = __webpack_public_path__ + "static/img/Model.16c20b74.png";